/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react'
import { createRoot } from 'react-dom/client'

import GlobalStateProvider from './src/hooks/GlobalStateProvider'
import loadPolyfills from './src/utils/polyfillUtils'

export const wrapRootElement = ({ element }) => {
  return <GlobalStateProvider>{element}</GlobalStateProvider>
}

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  return !!location.state && !!location.state.scroll
}

export const replaceHydrateFunction = () => (element, container, callback) => {
  loadPolyfills().then(modules => {
    const root = createRoot(container)
    root.render(element)
  })
}
